export default __webpack_public_path__ + "static/media/ninjacustoms-logo.131fa963.png";